export default {
    'welcome-text': 'Welcome to Acacia document management system',
    'select-company': 'Select company please',
}